/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiSegmentResult,
    InternalApiSegmentResultFromJSON,
    InternalApiSegmentResultToJSON,
} from '../models';

export interface FindTransactionSegmentResultsRequest {
    transactionId: string;
}

/**
 * 
 */
export class TransactionSegmentResultsApi extends runtime.BaseAPI {

    /**
     * Segments applied to the Transaction
     */
    async findTransactionSegmentResultsRaw(requestParameters: FindTransactionSegmentResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiSegmentResult>>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling findTransactionSegmentResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transactions/{transactionId}/segments`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiSegmentResultFromJSON));
    }

    /**
     * Segments applied to the Transaction
     */
    async findTransactionSegmentResults(requestParameters: FindTransactionSegmentResultsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiSegmentResult>> {
        const response = await this.findTransactionSegmentResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
